// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AccountingPage from "./AccountingPage.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as AccountingRoutes from "./AccountingRoutes.res.js";
import * as AccountingVendor from "../../modules/AccountingVendor.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as AccountingConfiguration from "../../modules/AccountingConfiguration.res.js";
import * as AccountingConfigurationPage from "./AccountingConfigurationPage.res.js";

function AccountingRouter(props) {
  let subUrlPath = props.subUrlPath;
  let userRole = Auth.useRole();
  if (!Auth.isAuthorizedAccess(userRole, AccountingRoutes.baseRoute)) {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
  if (subUrlPath === 0) {
    return JsxRuntime.jsx(AccountingPage.make, {
      configurationRoute: AccountingRoutes.configurationRoute,
      getShopAccountingConfigurationRequest: AccountingConfiguration.request
    });
  }
  let match = subUrlPath.tl;
  if (match !== 0 && match.hd === "configuration") {
    let match$1 = match.tl;
    if (match$1 !== 0 && match$1.tl === 0) {
      let vendor = AccountingVendor.fromString(match$1.hd);
      if (vendor !== undefined) {
        return JsxRuntime.jsx(AccountingConfigurationPage.make, {
          getAllShopTaxesRequest: AccountingConfigurationPage.getAllShopTaxesRequest,
          getShopAccountingConfigurationRequest: AccountingConfiguration.request,
          createOrUpdateShopAccountingConfigurationRequest: AccountingConfigurationPage.createOrUpdateShopAccountingConfigurationRequest,
          configurationRoute: AccountingRoutes.configurationRoute,
          baseRoute: AccountingRoutes.baseRoute,
          shopId: subUrlPath.hd,
          vendor: vendor
        });
      } else {
        return JsxRuntime.jsx(Navigation.Redirect.make, {
          route: AccountingRoutes.baseRoute
        });
      }
    }
  }
  return JsxRuntime.jsx(Navigation.Redirect.make, {
    route: AccountingRoutes.baseRoute
  });
}

let getAllShopTaxesRequest = AccountingConfigurationPage.getAllShopTaxesRequest;

let createOrUpdateShopAccountingConfigurationRequest = AccountingConfigurationPage.createOrUpdateShopAccountingConfigurationRequest;

let getShopAccountingConfigurationRequest = AccountingConfiguration.request;

let make = AccountingRouter;

export {
  getAllShopTaxesRequest,
  createOrUpdateShopAccountingConfigurationRequest,
  getShopAccountingConfigurationRequest,
  make,
}
/* Auth Not a pure module */
